<template>
  <div class="analysis-container">
    <el-row :gutter="20" class="summary-row">
      <el-col :xs="24" :sm="12" :lg="6" v-for="item in summaries" :key="item.title">
        <div class="summary-card">
          <svg-icon :icon="item.icon"></svg-icon>
          <div>
            <div class="summary-title">{{ item.title }}</div>
            <div class="summary-value">{{ item.value }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-card class="chart-card">
      <div id="operations-chart" class="chart"></div>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { LANGUAGE_EVENT, translateUi } from '@/i18n'

export default {
  name: 'Analysis',

  data () {
    return {
      chart: null,
      summaries: [
        { icon: 'user', get title () { return translateUi('用户数量') }, value: '--' },
        { icon: 'role', get title () { return translateUi('角色数量') }, value: '--' },
        { icon: 'menu', get title () { return translateUi('菜单数量') }, value: '--' },
        { icon: 'log', get title () { return translateUi('今日操作数') }, value: '--' }
      ]
    }
  },

  mounted () {
    this.chart = echarts.init(document.getElementById('operations-chart'))
    this.renderChart()
    window.addEventListener('resize', this.handleResize)
    // 图表绘制在 canvas 中，DOM 文案替换机制无法覆盖，切换语言后需主动重绘
    window.addEventListener(LANGUAGE_EVENT, this.renderChart)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener(LANGUAGE_EVENT, this.renderChart)
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },

  methods: {
    handleResize () {
      if (this.chart) this.chart.resize()
    },
    renderChart () {
      if (!this.chart) return
      const en = this.$locale === 'en'
      this.chart.setOption({
        title: { text: en ? 'Operations in the Last 7 Days' : translateUi('近七日操作量') },
        tooltip: { trigger: 'axis' },
        xAxis: { type: 'category', data: en ? ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] : ['一', '二', '三', '四', '五', '六', '日'] },
        yAxis: { type: 'value' },
        series: [{ name: en ? 'Operations' : '操作量', type: 'line', smooth: true, data: [0, 0, 0, 0, 0, 0, 0] }]
      }, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.analysis-container {
  padding: 20px;

  .summary-row {
    margin-bottom: 20px;
  }

  .summary-card {
    display: flex;
    align-items: center;
    min-height: 82px;
    padding: 16px;
    background: #fff;
    border: 1px solid #ebeef5;

    .svg-icon {
      margin-right: 14px;
      font-size: 32px;
      color: #409eff;
    }
  }

  .summary-title {
    color: #909399;
    font-size: 13px;
  }

  .summary-value {
    margin-top: 8px;
    color: #303133;
    font-size: 22px;
    font-weight: 600;
  }

  .chart-card {
    .chart {
      width: 100%;
      height: 420px;
    }
  }
}
</style>
